import { BaseEntity } from 'src/app/tools/models/baseEntity'
import { Itinerary } from './itinerary-entity';
import { Partner } from '../master-data/partner-entity';


export class ItineraryPartner extends BaseEntity {

    itinerary           : Itinerary = new Itinerary();
    itinerarylinenumber : number;
    partner             : Partner;
    rank                : number;
}